import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { LoginTemplate } from "~/features/auth/LoginTemplate";
import { useAuthStore } from "~/stores/useAuthStore";

const loginSearchSchema = z.object({
  app: z.string().optional(),
  appId: z.coerce.string().optional(),
  lang: z.string().optional(),
  email: z.string().optional(),
  pwd: z.string().optional(),
});

export const Route = createFileRoute("/login")({
  validateSearch: loginSearchSchema,
  beforeLoad: () => {
    const token = useAuthStore.getState().token;
    if (token) {
      throw redirect({ to: "/" });
    }
  },
  component: LoginTemplate,
});
